import React from 'react'
import Modal from './Modal'
import css from './Modal.module.scss'
import lCss from '../Layout/Layout.module.scss'

export default function ModalError({isOpen,closeModal}) {
	return (
		<Modal
			isOpen={isOpen}
			closeModal={closeModal}
			style={{
				content: {
					position:'static',
					display: 'inline-block',
					background: '#fff',
					overflow: 'auto',
					border: 'none',
					WebkitOverflowScrolling: 'touch',
					outline: 'none',
					boxShadow: '5px 15px 25px rgba(0, 0, 0, 0.5)',
					borderRadius: 'none',
					padding: '0',
					width:'480px',
					maxWidth: '100%',
					margin: '0 auto'
				}
			}}
		>
			<>
				<div className={css.title}>Ошибка</div>
				<input type="button" className={lCss.button + ' ' + lCss.w100} value="Закрыть" onClick={closeModal}/>
			</>
		</Modal>
	)
}